import {RoleModel} from "../Model/Compte/RoleModel";

export class RolesEnum {
        public static SuperAdmin = "81761294-53C2-4A4A-8603-93489327A06A";
        public static User = "6A92F3DC-A8EE-4232-B940-D3F2618CE530";
    }
    
    export class Roles {
        static #_instance: Roles;

        static get Instance(): Roles {
            if (!Roles.#_instance) {
                Roles.#_instance = new Roles();
            }
            return Roles.#_instance;
        }

        #items: Map<string, string> = new Map<string, string>();

        public get Items(): Map<string, string> {
            return this.#items;
        }

        constructor() {
            this.#items.set(RolesEnum.SuperAdmin, "Super Admin");
            this.#items.set(RolesEnum.User, "User");
        }

        public GetById = (id: string) => this.#items.get(id);
        public ToArray = (): RoleModel[] =>
            Array.from(this.#items.entries()).map(([id, nom]) => {
                const role = new RoleModel();
                role.Primarykey = id;
                role.Libelle = nom;
                return role;
            });
    }
    